var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.consultationSlotClick}},[_c('img',{attrs:{"src":"http://www.xdf.cn/zhuanti/school/wapm8.27/m1/img/xtb4.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("咨询")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-047d0dcc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FooterConsultationInfo.vue
// module id = 375
// module chunks = 0 1 2